import {Box} from "@mui/material";

export default function CategorySkeleton() {
    return (<>
        <Box sx={{
            minHeight : "40vh"
        }}></Box>
        </>)
}